"use client"
import { Button } from "@/components/ui/Button"
import * as Sentry from "@sentry/nextjs"
import { useEffect } from "react"

export default function Page({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <div className="flex items-center justify-center p-20">
      <div className="space-y-2">
        <h2 className="text-4xl">Something went wrong!</h2>
        <p>We have been notified.</p>
        <Button variant="secondary" onClick={() => reset()}>
          Try again
        </Button>
      </div>
    </div>
  )
}
